module.exports = __webpack_public_path__ + "img/t1-position.4710f56c.png";